import { Component, inject, OnInit } from '@angular/core';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import {
  AlertModalComponent
} from "../../warehouse-management/warehouse-management-dashboard/alert-modal/alert-modal.component";
import {
  TempStabilityModalComponent
} from "../../warehouse-management/warehouse-management-dashboard/temp-stability-modal/temp-stability-modal.component";
import {
  HumidityStabilityModalComponent
} from "../../warehouse-management/warehouse-management-dashboard/humidity-stability-modal/humidity-stability-modal.component";

import { Router } from '@angular/router';
import { SettingsService } from '../../../services/settings.service';
import { GraphqlService } from '../../../services/graphql.service';
import { GET_USERS_DASHBOARD_QUERY } from "../../../store/entities/user-management/users-dashboard/users-dashboard.graphql";
import { RadialBarsDataProps } from "../../../shared/components/graphs/radialbars-graph/radialbars-graph.component";

@Component({
  selector: 'app-user-management-dashboard',
  templateUrl: './user-management-dashboard.component.html',
  styleUrls: ['./user-management-dashboard.component.scss']
})
export class UserManagementDashboardComponent implements OnInit {
  private router: Router = inject(Router);
  private settingsService: SettingsService = inject(SettingsService);
  private apollo: GraphqlService = inject(GraphqlService);

  loadingData: boolean;
  showChart: boolean;
  dashboardData: any;

  protected readonly faCircle = faCircle;
  title: string;

  barChartData: any[] = [];
  // pieChartData: RadialBarsDataProps[] =[];
  xAxis: string[] = [];

  async ngOnInit() {
    await this.fetchUsersDashboardData();
    this.title = '  ';
  }

  cardClicked(type: 'total' | 'active' | 'inactive' | 'roles') {
    switch (type) {
      case 'total':
        this.router.navigateByUrl('/manage/user-management/user-list');
        break;
      case 'active':
        this.router.navigate(['/manage/user-management/user-list'], { queryParams: { filter: 'active' } });
        break;
      case 'inactive':
        this.router.navigate(['/manage/user-management/user-list'], { queryParams: { filter: 'inactive' } });
        break;
      case 'roles':
        this.router.navigateByUrl('/manage/user-management/system-user-roles-list');
        break;
    }
  }

  async fetchUsersDashboardData(): Promise<void> {
    this.loadingData = true;
    this.showChart = false;
    try {
      const response: any = await this.apollo.query({
        query: GET_USERS_DASHBOARD_QUERY,
        variables: {},
      });

      const dashboardDataArray = response?.data?.getUsersDashboard?.data;
      if (dashboardDataArray && dashboardDataArray?.length > 0) {
        const dashboardData = dashboardDataArray[0];
        this.dashboardData = {
          totalUsers: dashboardData.totalUsers,
          activeUsers: dashboardData.activeUsers,
          inActiveUsers: dashboardData.inActiveUsers,
          totalRoles: dashboardData.totalRoles,
          userByRoles: dashboardData.userByRoles,
        };

        this.populateChartsData(dashboardData.userByRoles);
      } else {
        console.error("dashboardData is not available");
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      this.loadingData = false;
      this.showChart = true;
    }
  }

  populateChartsData(userByRoles: any[]): void {
    this.barChartData = [
      {
        name: 'Users per Role',
        data: userByRoles.map(role => ({
          x: role.roleName,
          y: role.numberOfUsers
        }))
      }
    ];

    setTimeout(() => {
      this.xAxis = userByRoles.map(role => role.roleName);
    }, 1000);

    this.pieChartData = userByRoles.map((role, index) => ({
      name: role.roleName,
      color: this.getRoleColor(index),
      data: Number(role.percentageOfUsers.toFixed(2))
    }));
  }
  pieChartData: RadialBarsDataProps[] = [];

  getRoleColor(roleIndex: number): string {
    const colorPalette = [
      '#FF6F61', '#34B9A7', '#0099FF', '#FFB800', '#8E44AD', '#00BFFF', '#FFD700', '#32CD32'
    ];
    return colorPalette[roleIndex % colorPalette?.length];
  }

}
